
const pageNames = [
  'home', 'rules', 'play', 'moremath', 'about'
]

export default pageNames
